import { render } from "./OrderPage.vue?vue&type=template&id=0bb4829f&scoped=true"
import script from "./OrderPage.vue?vue&type=script&lang=js"
export * from "./OrderPage.vue?vue&type=script&lang=js"

import "./OrderPage.vue?vue&type=style&index=0&id=0bb4829f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/colordemy-customers/colordemy-customers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bb4829f"]])

export default __exports__